import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { parseSummarySearch } from '../../../features/sales/model/summary.ts';
import { SalesHeader } from '../../../features/sales/ui/sales-tabs.tsx';
import { SummaryPage } from '../../../features/sales/ui/summary-page.tsx';
import { requirePermissionRoute } from '../../../lib/permissions.ts';

export const Route = createFileRoute('/_app/sales/summary')({
  validateSearch: (search: Record<string, unknown>) => parseSummarySearch(search),
  beforeLoad: requirePermissionRoute('sales.use'),
  component: SummaryRoute,
});

/**
 * «Сводка» за месяц (`/sales/summary?month=ГГГГ-ММ`): лиды, выиграно и проиграно, причины проигрыша.
 * Месяц живёт в адресе — ссылкой можно поделиться.
 */
function SummaryRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <div className="relative flex min-h-full w-full flex-col gap-4 px-4 py-5 md:px-6">
      <SalesHeader />
      <SummaryPage
        month={search.month}
        onMonth={(month) => {
          void navigate({ search: { month }, replace: true });
        }}
      />
    </div>
  );
}
